import { render, staticRenderFns } from "./PromotionSubsetBrand.vue?vue&type=template&id=438c0652&"
import script from "./PromotionSubsetBrand.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports